/**
 * Emits the Shopify standard `shopify:page:view` event on every page load.
 * See: shopify.dev/docs/storefronts/themes/best-practices/standard-events
 */
import { PageViewEvent } from '@shopify/events';

function dispatchPageViewEvent() {
  const main = document.querySelector('main[data-template]');
  const template = main?.dataset.template || '';

  document.dispatchEvent(
    new PageViewEvent({
      page: {
        template,
        title: document.title,
        url: window.location.href,
      },
    })
  );
}

if (document.readyState !== 'loading') {
  dispatchPageViewEvent();
} else {
  document.addEventListener('DOMContentLoaded', dispatchPageViewEvent, { once: true });
}
